import { render, staticRenderFns } from "./EditAdDetails.vue?vue&type=template&id=3bbc97d4&scoped=true&"
import script from "./EditAdDetails.vue?vue&type=script&lang=js&"
export * from "./EditAdDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditAdDetails.vue?vue&type=style&index=0&id=3bbc97d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc97d4",
  null
  
)

export default component.exports